export const paginate = (src: any, page: number, perPage: number) => {
  const lastIndex = page * perPage;
  const firstIndex = lastIndex - perPage;
  const paginated = src.slice(firstIndex, lastIndex);

  return paginated;
};
